import NetworkLogic from "../../Shared/NetworkLogic";
import Player from "../../Models/Player";

class SignData {

    private _bSignSwitch = null;//开关
    private _bCanSign = null;//
    private signSignInData = null;

    constructor() {

    }


    resetSignData(){
        this._bCanSign = null;
        this.signSignInData = null;
        this._bSignSwitch = null
    }

    async getSignSwitch() {
        if (this._bSignSwitch === null) {
            this._bSignSwitch = await this._getSignSwitch()
        }
        return this._bSignSwitch;
    }

    async getCanSign() {//是否弹出签到框
        let signSwitch = await this.getSignSwitch();
        if (!signSwitch) {
            this._bCanSign = false;
            return this._bCanSign;
        }
        if (this._bCanSign === null) {
            if (!this.signSignInData) {
                this.signSignInData = await this._signInSignGet()
            }
            let signData = this.signSignInData.signData;
            let bSign = false;
            for (let i = 0; i < signData.length; i++) {
                if (signData[i].whetherNotSignIn === 1) {//可签到
                    cc.log("====whetherNotSignIn i:w:",i,signData[i].whetherNotSignIn);
                    bSign = true;
                    break;
                }
            }
            this._bCanSign = bSign
        }
        return this._bCanSign;
    }

    async getSignData() {//获取签到数据
        if (!this.signSignInData) {
            this.signSignInData = await this._signInSignGet();

        }
        return this.signSignInData
    }


    _getSignSwitch():Promise<any>{
        return new Promise<any>(resolve => {
            NetworkLogic.signGetSignSwitch({},function (bOpen) {
                this.bSignSwitch = bOpen;
                resolve(bOpen)
            }.bind(this),function () {
                resolve(false)
            }.bind(this));
        })
    }

    _signInSignGet():Promise<any>{
        if (!Player.isLogedIn()) return ;
        return new Promise(resolve => {
            NetworkLogic.signInSignGet({}, async function (rec) {
                resolve(rec);
            }.bind(this), function (err) {
                resolve(null)
            })
        })
    }

}
export default new SignData();
